import { PrimaryButton } from '@photosi/rn-components/buttons/primary-button/PrimaryButton';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { View } from 'react-native';
import { TestIDs } from 'src/constants/testIDs.constants';
import { modalTestID } from 'src/helpers/testIDs.helper';

import { UploadScreenChildProps } from '../UploadScreen.types';

export type ErrorRetryComponentProps = UploadScreenChildProps;

export const ErrorRetryComponent = ({
  onPressRetry,
  title,
  description,
  illustrationName,
  ctaText,
  style,
}: ErrorRetryComponentProps) => {
  return (
    <View style={style.uploadContent}>
      <View style={{ width: 56, height: 56 }}>
        <Illustration name={illustrationName} />
      </View>
      <View style={style.textWrapper}>
        <TextLato style={style.title}>{title}</TextLato>
        <TextLato style={style.text}>{description}</TextLato>
      </View>
      <View>
        <PrimaryButton
          style={style.button}
          onPress={onPressRetry}
          testID={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.CHOOSE)}
          focusId={modalTestID(TestIDs.CHOOSE_PHOTO, TestIDs.CHOOSE)}
          focusOrder={0}
          focusGroup={FocusGroups.CHOOSE_PHOTO_BANNER}
          text={ctaText}
          textStyle={style.buttonText}
        />
      </View>
    </View>
  );
};
